module.exports = "/_next/static/images/b6c2a0c3e3f14bba47d7134cbce89d6e-prepayment_example.png";